exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-i18n-input .yxt-textarea .yxt-input__count{right:40px !important}\n", ""]);

